import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import ListErrors from '../../Utils/ListErrors';
import { getLabel } from '../../../language';
import '../../../css/register.css';
import ReCAPTCHA from 'react-google-recaptcha';
import agent from '../../../agent';
import { APP_CONFIG } from "../../../appconfig"
import {
    UPDATE_FIELD_AUTH,
    REGISTER,
    REGISTER_PAGE_UNLOADED
} from '../../../constants/actionTypes';
import FacebookLogin from "react-facebook-login";

const recaptchaSiteKey = APP_CONFIG.recaptchaSiteKey;

const mapStateToProps = state => ({ ...state.auth });

const mapDispatchToProps = dispatch => ({
    onSubmit: (/*userName,*/ email, password, locations, gRecaptchaResponse) => {
        let payload = agent.Auth.register(/*userName,*/ email, password, gRecaptchaResponse);
        dispatch({ type: REGISTER, payload });
        return payload;
    },
    onChangeRecaptchaToken: value =>
        dispatch({ type: UPDATE_FIELD_AUTH, key: 'gRecaptchaResponse', value }),
    onUnload: () =>
        dispatch({ type: REGISTER_PAGE_UNLOADED })
});


// pollyLogin: true, pathname: window.location.pathname

export class SignUpView extends React.Component {
    constructor() {
        super();
        this.state = {
            // userName: "",
            email: "",
            password: "",
            facebookAccess: "",
            captchaAccepted: false
        }
    }

    componentWillMount() {
        this.registerWithTwitter()
    }
    componentDidMount() {
        document.getElementById("content").classList.remove("container");
    }

    componentWillUnmount() {
        this.props.onUnload()
    }

    onSubmitClick = (ev) => {
        ev.preventDefault();
        if (this.state.facebookAccess) {
            agent.Auth.facebookSignup(/*this.state.userName,*/ this.state.email, this.state.password, this.state.facebookAccess).then(
                res => {
                    if (res.userId && this.props.isConfirmSignup) {
                        this.setState({
                            registerSuccess: true,
                        })
                    }
                }
            )
        } else {
            this.props.onSubmit(/*this.state.userName,*/ this.state.email, this.state.password, this.state.selected_location, this.props.gRecaptchaResponse).then(
                res => {
                    if (res.userId) {
                        this.setState({
                            registerSuccess: true,
                        })
                    }
                }
            );
        }
    }

    fieldsErrors = () => {
        let errors = {};
        if (this.props.errors && this.props.errors.errors && this.props.errors.errors.length > 0) {
            this.props.errors.errors.forEach(item => {
                errors[item.fieldName] = item.message.toString().replace(/[']/g, "");
            });
        }
        return errors;
    }

    generalErrors = () => {
        let errors = [];
        if (this.props.errors && this.props.errors.errors && this.props.errors.errors.length == 0) {
            errors.push(this.props.errors.message.replace(/[']/g, ""));
        }
        return errors;
    }

    verifyRecaptchaCallback = (response) => {
        this.setState({
            captchaAccepted: true
        });
        this.props.onChangeRecaptchaToken(response);
    }

    handelChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }


    // openModal = (name) => {
    //     const infoName = info.filter(info => info.title === name);
    //     if (infoName.length) {
    //         const infoTitle = infoName[0].title || '';
    //         const infoDescription = infoName[0].description || '';
    //         this.setState({ isOpen: !this.state.isOpen, infoTitle, infoDescription })
    //     } else {
    //         this.setState({ isOpen: !this.state.isOpen })
    //     }
    // }

    responseFacebook = (response) => {
        if (response && response.accessToken) {
            this.setState({
                facebookAccess: response.accessToken
            })
            this.props.onChangeEmail(response.email);
        }
    }
    componentClicked = () => { }

    registerWithTwitter = () => {
        agent.Auth.getAuthToken(window.location.origin + "/register").then(res => {
            window.location.href = `https://api.twitter.com/oauth/authenticate?oauth_token=${res.oauth_token}`;
            this.setState({
                oauth_token: res.oauth_token,
            })
        }, err => {
            // this.setState({
            //     errMsg: "err.message"
            // })
            console.log(err)
        })
    }

    render() {
        const formErrors = this.fieldsErrors();
        const generalErrors = this.generalErrors();
        const { captchaAccepted, email, password } = this.state;
        return (
            <div className="content signup-view-modal">
                {
                    this.state.registerSuccess ? <p>{getLabel(235)}</p> :
                        <div>
                            <ListErrors errors={this.props.errors} />
                            {
                                (generalErrors && generalErrors.length > 0) ? generalErrors.map(res => {
                                    return <div className="has-danger"><span className="form-control-feedback">{res}</span></div>
                                }) : null
                            }
                            {/*<div className="text-danger">{this.state.errMsg}</div>*/}
                            {/*<div className="forms-group">*/}
                            {/*    <div className="form-group">*/}
                            {/*        <input*/}
                            {/*            className="form-control"*/}
                            {/*            type="text"*/}
                            {/*            placeholder={getLabel(7)}*/}
                            {/*            name="userName"*/}
                            {/*            value={userName}*/}
                            {/*            onChange={this.handelChange} />*/}
                            {/*        <div className="form-control-feedback">{formErrors['UserName'] ? formErrors['UserName'] : ''}</div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <h6>{getLabel(334)}</h6>
                            <div className="forms-group">
                                <div className="form-group">
                                    <input
                                        className="form-control"
                                        type="email"
                                        name="email"
                                        placeholder={getLabel(1)}
                                        value={email}
                                        onChange={this.handelChange} />
                                    <div className="form-control-feedback">{formErrors['UserName'] ? formErrors['UserName'] : ''}</div>
                                </div>
                            </div>

                            <div className="forms-group">
                                <div className="form-group">
                                    <input
                                        className="form-control"
                                        type="password"
                                        name="password"
                                        placeholder={getLabel(2)}
                                        value={password}
                                        onChange={this.handelChange} />
                                    <div className="form-control-feedback">{formErrors['Password'] ? formErrors['Password'] : ''}</div>
                                </div>
                            </div>

                            <div className="forms-group">
                                <div className="form-group">
                                    <div style={{ Width: 304, Height: 78 }}>
                                        <ReCAPTCHA
                                            sitekey={recaptchaSiteKey}
                                            onChange={this.verifyRecaptchaCallback}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="clearfix" />
                            <div className="actionbuttons">
                                <input className="btn btn-primary" disabled={!captchaAccepted} onClick={this.onSubmitClick} type="submit" value="Submit" />
                                <span className="handwritten">{getLabel(233)}</span>

                                {/*<FacebookLogin*/}
                                {/*    appId="1575374426048627"*/}
                                {/*    autoLoad={false}*/}
                                {/*    fields="name, email"*/}
                                {/*    disableMobileRedirect={true}*/}
                                {/*    icon="fa-facebook"*/}
                                {/*    textButton={getLabel(231)}*/}
                                {/*    cssClass="btn btn-facebook btn-block"*/}
                                {/*    onClick={this.componentClicked}*/}
                                {/*    callback={this.responseFacebook} />*/}

                                <a onClick={this.registerWithTwitter} className="btn btn-info">
                                    <i className="fa fa-twitter" /> {getLabel(232)}
                                </a>

                            </div>
                            <span className="pointer" onClick={this.props.onLoginModal}>{getLabel(236)}</span>
                        </div>
                }
            </div>
        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SignUpView));
